export default __webpack_public_path__ + "static/media/amazon 2.eea66bec.PNG";